// React
import React from 'react';
import PropTypes from 'prop-types';

// Css
import './index.scss';

export const AddressCell = ({ params }) => {
  const {
    name,
    contactNo,
    addressLine1,
    addressLine2,
    city,
    district,
    state,
    country,
    postalCode,
    className
  } = params.data;

  return (
    <div className={`pickup-address__address-cell ${className}`}>
      <div className='pickup-address__company-name'>{name}</div>
      <div className='pickup-address__address-line'>{addressLine1}</div>
      <div className='pickup-address__address-line'>{addressLine2}</div>
      <div className='pickup-address__address-line'>
        {city}, {district}
      </div>
      <div className='pickup-address__address-line'>
        {state}, {country}
      </div>
      <div className='pickup-address__contact-info'>
        <span className='pickup-address__pincode'>{postalCode},</span>
        <span className='pickup-address__phone'> {contactNo}</span>
      </div>
    </div>
  );
};

export const CustomHeader = ({ onAddClick, title, button, icon }) => {
  return (
    <div className='pickup-address__custom-header'>
      <span className='pickup-address__header-title'>{title}</span>
      <button
        className='pickup-address__add-btn-header'
        onClick={onAddClick}
        title='Add Pickup Address'
      >
        <i className={icon}></i>
        <span>{button}</span>
      </button>
    </div>
  );
};

AddressCell.propTypes = {
  params: PropTypes.shape({
    data: PropTypes.shape({
      name: PropTypes.string,
      contactNo: PropTypes.string,
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      city: PropTypes.string,
      district: PropTypes.string,
      state: PropTypes.string,
      country: PropTypes.string,
      postalCode: PropTypes.string
    })
  }).isRequired
};

CustomHeader.propTypes = {
  onAddClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
};
